import React, { useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import UserProfile from './UserProfile';
import UserDetails from './UserDetails';
import {
    UserPanelContainer,
    HR,
    DialogContainer,
    LabelRegularStyle,
    LabelDemiStyle,
} from './UserPanel.styled';
import {
    accountNumberZeroTrimmer,
    forbiddenErrorCheck,
    resumeScrolling,
    checkProxyActive,
    checkImpersonationActive,
} from 'src/utils/util';
import { useTranslation } from 'react-i18next';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import { getHybrisUserDetails } from 'src/common/redux/actions';

const UserPanel = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const userDetails = useSelector(
        (state) => state.loginReducer.hybrisUserDetails
    );

    const bannerInfo = useSelector(
        (state) => state.loginReducer.bannerInfo,
        shallowEqual
    );
    const isDestructiveEnabled = useSelector(
        (state) => state.loginReducer.isDestructiveEnabled
    );
    const isDestructive =
        isDestructiveEnabled ||
        (bannerInfo &&
            !checkProxyActive() &&
            !checkImpersonationActive() &&
            bannerInfo.filter(
                (item) => item.messageType === 'userDestructiveMessage'
            ).length > 0);
    const {
        displayName,
        firstName,
        lastName,
        emailId,
        phoneNumber,
        officeLocation,
        employeeRole,
        salesStructure,
        networkId,
        managerFirstName,
        managerLastName,
        sapID,
    } = userDetails;

    const [isProfileDailogeOpen, setProfileDailoge] = useState(false);
    const [, setPosition] = useState('center');
    // const [isForbidden, setIsForbidden] = useState(false);

    const openProfileDialog = (name, position) => {
        dispatch(getHybrisUserDetails());
        props.clicked();
        setProfileDailoge(true);
        if (position) {
            setPosition(position);
        }
    };
    const initiateProxyStatus = useSelector(
        (state) => state.InitiateProxyReducer.statusCode
    );

    // const isForbidden = useSelector(
    //     (state) => state.loginReducer.isForbidden
    // );

    // eslint-disable-next-line no-unused-vars
    const onHide = (name) => {
        setProfileDailoge(false);
    };
    // useEffectWithErrorLogging(()=>{
    //     setIsForbidden(true);
    // },[]);
    // useEffectWithErrorLogging(()=>{
    //     forbiddenErrorCheck(instance, dispatch, logoutAPI) ? setIsForbidden(false) : setIsForbidden(true);
    // }, [isForbidden]);
    useEffectWithErrorLogging(() => {
        if (initiateProxyStatus === '200') {
            onHide();
        }
    }, [initiateProxyStatus]);
    useEffectWithErrorLogging(() => {
        if (isProfileDailogeOpen) {
            resumeScrolling();
        }
    }, [isProfileDailogeOpen]);

    return (
        <>
            <UserPanelContainer isSideNavBar={props.isSideNavBar}>
                <UserProfile
                    givenName={firstName}
                    surname={lastName}
                    userPrincipalName={employeeRole}
                    openProfileDialog={openProfileDialog}
                    isSideNavBar={props.isSideNavBar}
                    hasBanner={props.hasBanner}
                    onHide={onHide}
                    closeSideNavBar={props.clicked}
                />
                {props.isSideNavBar ? <HR /> : null}
                {props.isSideNavBar &&
                !isDestructive &&
                !forbiddenErrorCheck() ? (
                    <UserDetails
                        officeLocation={officeLocation}
                        jobTitle={employeeRole}
                        salesStructure={salesStructure}
                        openProfileDialog={openProfileDialog}
                        isSideNavBar={props.isSideNavBar}
                        hasBanner={props.hasBanner}
                    />
                ) : null}
            </UserPanelContainer>
            <DialogContainer
                id="user-profile-dialog"
                draggable={false}
                header={t('common.myProfileLabel')}
                visible={isProfileDailogeOpen}
                onHide={() => onHide()}
                resizable={false}
                blockScroll={true}
                baseZIndex={2020}
            >
                <LabelDemiStyle>{t('common.nameLabel')}</LabelDemiStyle>
                <LabelRegularStyle>
                    {displayName ? displayName : t('common.naLabel')}
                </LabelRegularStyle>

                <LabelDemiStyle topMargin="20px">
                    {t('userPanel.roleLabel')}
                </LabelDemiStyle>
                <LabelRegularStyle>
                    {employeeRole ? employeeRole : t('common.naLabel')}
                </LabelRegularStyle>

                <LabelDemiStyle topMargin="20px">
                    {t('userPanel.networkLabel')}
                </LabelDemiStyle>
                <LabelRegularStyle>
                    {networkId ? networkId : t('common.naLabel')}
                </LabelRegularStyle>

                <LabelDemiStyle topMargin="20px">
                    {t('userPanel.emailLabel')}
                </LabelDemiStyle>
                <LabelRegularStyle breakWord>
                    {emailId ? emailId : t('common.naLabel')}
                </LabelRegularStyle>

                <LabelDemiStyle topMargin="20px">
                    {t('userPanel.contactLabel')}
                </LabelDemiStyle>
                <LabelRegularStyle>
                    {phoneNumber ? phoneNumber : t('common.naLabel')}
                </LabelRegularStyle>

                <LabelDemiStyle topMargin="20px">
                    {t('userPanel.managerLabel')}
                </LabelDemiStyle>
                <LabelRegularStyle>
                    {managerFirstName || managerLastName ? (
                        <>
                            {managerFirstName} {managerLastName}
                        </>
                    ) : (
                        t('common.naLabel')
                    )}
                </LabelRegularStyle>
                <LabelDemiStyle topMargin="20px">
                    {t('userPanel.sapLabel')}
                </LabelDemiStyle>
                <LabelRegularStyle>
                    {sapID
                        ? accountNumberZeroTrimmer(sapID)
                        : t('common.naLabel')}
                </LabelRegularStyle>

                <LabelDemiStyle topMargin="20px">
                    {t('userPanel.salesStructureLabel')}
                </LabelDemiStyle>
                {salesStructure ? (
                    salesStructure?.map((item, index) => {
                        return (
                            <React.Fragment key={index}>
                                <LabelRegularStyle key={item.salesForceId}>
                                    <span>
                                        <span>
                                            {item.salesOrg}.{item.salesForceId}.
                                            {item.salesHierarchyUid}
                                        </span>
                                        <br />
                                        {item.district}
                                        <br />
                                        <span>{item.territory}</span>
                                    </span>
                                </LabelRegularStyle>
                                <br />
                            </React.Fragment>
                        );
                    })
                ) : (
                    <LabelRegularStyle>{t('common.naLabel')}</LabelRegularStyle>
                )}
            </DialogContainer>
        </>
    );
};

export default UserPanel;
